/**
 * Utilitaire DOM sécurisé pour espace-pro-static
 * Résout les conflits avec underscore.js et fournit des méthodes DOM compatibles
 */

// Fonction d'aide pour vérifier les types
function isElement(el) {
  return el && typeof el === 'object' && el.nodeType === 1;
}

function isFunction(fn) {
  return typeof fn === 'function';
}

// Récupération sécurisée des attributs
export function getAttributeValue(element, attributeName) {
  if (!isElement(element)) return null;
  
  const attribute = element.attributes[attributeName];
  return attribute ? attribute.value : null;
}

// Vérification sécurisée des attributs multiples
export function checkAttributeValues(element, attributeChecks) {
  if (!isElement(element) || !Array.isArray(attributeChecks)) return false;
  
  return attributeChecks.every(check => {
    const value = getAttributeValue(element, check.name);
    return value === check.expected;
  });
}

// addEventListener sécurisé
export function addEventListener(element, event, handler, options = {}) {
  if (!isElement(element) || !isFunction(handler)) {
    console.warn('DOM addEventListener: Invalid element or handler');
    return false;
  }
  
  try {
    element.addEventListener(event, handler, options);
    return true;
  } catch (error) {
    console.error('DOM addEventListener error:', error);
    return false;
  }
}